export enum PlannerTaskStatus {
  NOT_STARTED = 'not_started',
  TO_DO = 'to_do',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}
